import { motion } from "framer-motion";
import ParticlesBackground from "./ParticlesBackground";

export default function HeroSection({ t }) {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center text-center overflow-hidden"
      style={{ background: "linear-gradient(180deg, #050505 0%, #0A0F1A 100%)" }}
    >
      <ParticlesBackground />

      {/* Gradient orbs */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full bg-[#0055FF]/10 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] rounded-full bg-[#00F0FF]/8 blur-[100px] pointer-events-none" />

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[#00F0FF] font-semibold mb-6 block font-chivo">
            ETRADE d.o.o.
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-bold text-white leading-tight font-outfit mb-6">
            {t.hero.headline}
          </h1>
          <p className="text-base md:text-lg text-[#94A3B8] max-w-2xl mx-auto mb-10 font-chivo leading-relaxed">
            {t.hero.subheadline}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollTo("#contact")}
              data-testid="hero-cta-consultation"
              className="bg-[#0055FF] hover:bg-[#0066FF] text-white px-8 py-4 rounded-full font-bold transition-all duration-300 shadow-[0_0_20px_rgba(0,85,255,0.4)] hover:shadow-[0_0_30px_rgba(0,240,255,0.6)] font-outfit text-sm tracking-wide"
            >
              {t.hero.cta1}
            </button>
            <button
              onClick={() => scrollTo("#contact")}
              data-testid="hero-cta-contact"
              className="bg-white/5 hover:bg-white/10 border border-white/20 hover:border-[#00F0FF]/50 text-white px-8 py-4 rounded-full font-bold transition-all duration-300 font-outfit text-sm tracking-wide"
            >
              {t.hero.cta2}
            </button>
          </div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <div className="w-5 h-8 rounded-full border-2 border-white/20 flex justify-center pt-1.5">
            <div className="w-1 h-2 rounded-full bg-[#00F0FF]" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
